import MultipleSpecifications from '../components/MultipleSpecifications.vue'
const confirmModal = {
  install: function(Vue) {
    const Msg = Vue.extend(MultipleSpecifications)
    const msg = new Msg()
    document.body.innerHTML += '<div id="MultipleSpecifications"><div id="MultipleSpecifications"></div></div>'
    msg.$mount('#MultipleSpecifications')
    Vue.prototype.$ProductSpec = function(options) {
      msg.open(options)
      return msg
    }
  }
}
export default confirmModal



// WEBPACK FOOTER //
// ./src/until/MultiplePopup.js